import Profile from 'routes/Profile'
import api, { getUserFromCtx } from 'shared/api'

const defaultProps = {}
const propTypes = {}

export async function getServerSideProps(context) {
  const user = getUserFromCtx(context)
  const host =
    context.req.headers['x-forwarded-host'] || context.req.headers.host
  const { query } = context
  const { username, post: postId } = query

  try {
    const { data } = await api.get(`/public/profile/${username}`, {
      headers: {
        Authorization: `Bearer ${user?.accessToken}`,
      },
    })

    if (!postId) {
      return {
        props: {
          username,
          host,
          data,
          user,
        },
      }
    }

    const postResquests = [
      api.get(`/public/posts/${postId}`),
      api.get('/comments', {
        headers: {
          Authorization: `Bearer ${user?.accessToken}`,
        },
        params: {
          reference: postId,
          type: 'Post',
          limit: 10,
          page: 1,
        },
      }),
    ]

    const [
      { data: postData },
      { data: commentsList, headers: { 'x-total-results': commentCount } = {} },
    ] = await Promise.all(postResquests)

    const { data: isLiked } = user?.accessToken
      ? await api.get(`/posts/liked/${postId}`, {
          headers: { Authorization: `Bearer ${user?.accessToken}` },
        })
      : { data: false }

    return {
      props: {
        username,
        host,
        data,
        user,
        postData: {
          ...postData,
          isLiked: isLiked || null,
          commentsData: {
            list: commentsList || [],
            total: commentCount || 0,
          },
        },
        seoConfig: {
          image: postData?.image || null,
          title: postData?.text || null,
          content: postData?.text || null,
        },
      },
    }
  } catch (e) {
    return {
      props: {
        errorCode: 404,
      },
    }
  }
}

export const Page = props => <Profile {...props} />

Page.defaultProps = defaultProps
Page.propTypes = propTypes

export default Page
